// Older SpiderVO exports concatenate labels without separators. Only split at
// word boundaries outside quotes, preserving names such as EfficientDynamics.
export function parseSpiderVOList(value) {
  if (Array.isArray(value)) return [...new Set(value.flatMap(parseSpiderVOList))];
  if (typeof value !== "string") return [];
  const text = value.replace(/<br\s*\/?\s*>/gi, "\n").replace(/\r\n?/g, "\n");
  const items = [];
  let current = "";
  let quoted = false;
  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    // A quote following a number is an inch mark, not an opening quote.
    if (char === '"' && (quoted || !/\d/.test(text[i - 1] || ""))) quoted = !quoted;
    const rest = text.slice(i);
    const previous = text[i - 1] || "";
    const camelBoundary = /[a-zà-ÿ)]/.test(previous) && /^[A-ZÀ-ÖØ-Þ][a-zà-ÿ]/.test(rest);
    const quoteBoundary = previous === '"' && /^[A-ZÀ-ÖØ-Þ][a-zà-ÿ]/.test(rest);
    const acronymBoundary = /(?:LED|ABS|DSC\+|DTC|CBC|EBV|USB|AUX-IN)$/.test(current) && /^[A-Z][a-zà-ÿ]/.test(rest);
    const acronymStart = /[a-zà-ÿ)]/.test(previous) && /^(?:ABS|BMW|LED|USB)\b/.test(rest);
    const suffixBoundary = /[A-Z0-9']/.test(previous) && /^[A-ZÀ-ÖØ-Þ][a-zà-ÿ]/.test(rest) && !/^(?:Go|Mo|Ko)\b/.test(rest);
    const numberedBoundary = /[a-zà-ÿ)]/.test(previous) && /^\d+ prises?\b/i.test(rest);
    const technicalName = /(?:Efficient|Twin|Connected|Select)$/.test(current) || /(?:^|\s)i$/.test(current) || /Tele$/.test(current);
    if (char === "\n" || (!quoted && !technicalName && (camelBoundary || quoteBoundary || acronymStart || suffixBoundary || acronymBoundary || numberedBoundary))) {
      if (current.trim()) items.push(current.trim());
      current = "";
      if (char === "\n") { quoted = false; continue; }
    }
    current += char;
  }
  if (current.trim()) items.push(current.trim());
  return [...new Set(items.map(item => item.replace(/^[•–]\s*|^-\s+/, "").replace(/\s+/g, " ").trim()).filter(Boolean))];
}
